/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
export const init = () => {
  if (window.cube.config.anly_useLegacy !== 'Y') return;
  const fwk = CUBE.Analytics;
  // TRACKER 'FILTERS'
  const tracker = new AnalyticsTracker(
    AnalyticsConstants.trackers.commons.filters
  );
  const isSearch = tc_vars.env_template === 'internal_search';
  let baseEvent = {};

  if (isSearch) {
    baseEvent = AnalyticsConstants.trackers.commons.search.defaultEvent;
    baseEvent.action = 'AdditionalSearch';
  } else {
    baseEvent = AnalyticsConstants.trackers.commons.filters.defaultEvent;
  }

  // - BTN TOGGLE FILTER
  const eventBtnToggle = new AnalyticsTriggerEvent('btnToggle', baseEvent);

  eventBtnToggle.trigger = 'click';
  eventBtnToggle.domContainer = '#main-container';
  eventBtnToggle.domElement =
    '#product-filters .m-filters-settings-item.toggler-col';

  eventBtnToggle.params = {};
  eventBtnToggle.params.valueOpen = 'Open';
  eventBtnToggle.params.valueClose = 'Close';
  eventBtnToggle.params.selectorSub = 'a';
  eventBtnToggle.params.dataTextOpened = 'close-text-long';
  eventBtnToggle.getLabel = function($element, data, jqEvent, jqData) {
    if (
      $element.text().trim() ===
      $element.find(this.params.selectorSub).data(this.params.dataTextOpened)
    )
      return this.params.valueClose;
    return this.params.valueOpen;
  };

  tracker.addEvent(eventBtnToggle);

  // - FILTER ON 'SELECT'
  const eventFilterSelect = new AnalyticsTriggerEvent(
    'filterSelect',
    baseEvent
  );

  eventFilterSelect.trigger = 'change';
  eventFilterSelect.domContainer = '#main-container';
  eventFilterSelect.domElement = '.m-filters-faceting-content select';

  eventFilterSelect.params = {};
  eventFilterSelect.params.type = 'select';
  eventFilterSelect.params.selectorName = 'option:first-child';
  eventFilterSelect.params.selectorValue = 'option:selected';
  eventFilterSelect.constructLabel = function($element) {
    const type = this.params.type;
    const name = $element
      .find(this.params.selectorName)
      .text()
      .trim();
    const value = $element
      .find(this.params.selectorValue)
      .text()
      .trim();
    return (
      type +
      AnalyticsConstants.concatenator +
      name +
      AnalyticsConstants.concatenator +
      value
    );
  };
  eventFilterSelect.getLabel = $element =>
    optionnalSearchedPhrase() + eventFilterSelect.constructLabel($element);
  eventFilterSelect.postAction(function(
    $element,
    data,
    jqEvent,
    jqData,
    event
  ) {
    const filterValue = $element
      .find(this.params.selectorValue)
      .data('filter-value');
    CUBE.Analytics.filters.setFilterInDataLayer($element, filterValue, true);
  });

  tracker.addEvent(eventFilterSelect);

  // - FILTER ON 'RANGE'
  const eventFilterRange = new AnalyticsTriggerEvent('filterRange', baseEvent);

  eventFilterRange.trigger = 'rangeChange';
  eventFilterRange.domContainer = '#product-filters';
  eventFilterRange.domElement = '#range_filter';
  eventFilterRange.params = {};
  eventFilterRange.params.type = 'range';
  eventFilterRange.getLabel = function($element, data, jqEvent, jqData) {
    const type = this.params.type;
    return (
      optionnalSearchedPhrase() +
      type +
      AnalyticsConstants.concatenator +
      jqData.from +
      AnalyticsConstants.concatenator +
      jqData.to
    );
  };
  eventFilterRange.postAction(($element, data, jqEvent, jqData, event) => {
    CUBE.Analytics.filters.setFilterInDataLayer(
      $element,
      jqData.from + AnalyticsConstants.concatenator + jqData.to,
      true
    );
  });

  tracker.addEvent(eventFilterRange);

  // - FILTER ON 'COLOR'
  const eventFilterColor = new AnalyticsTriggerEvent('filterColor', baseEvent);

  eventFilterColor.trigger = 'click';
  eventFilterColor.flagSend = false;
  //eventFilterColor.domContainer = '#main-container';
  eventFilterColor.domElement = '.m-filters-list-colors div.checkbox';
  // |--> We 'hack' the init for this event : for an unknow reason, 'eventFilterColor' is triggered twice...
  // | The modification consists to call the jQuery method 'one' (instead of 'on') in order to send it only once
  eventFilterColor.init = function() {
    $(this.domElement).one(
      `${this.trigger}.${AnalyticsConstants.namespace}`,
      this.bind()
    );
  };
  eventFilterColor.preInit = function() {
    this.flagSend = false;
  };
  eventFilterColor.postAction(($element, data, jqEvent, jqData, event) => {
    event.flagSend = true;
  });
  eventFilterColor.stopEvent = function() {
    return this.flagSend;
  };
  eventFilterColor.params = {};
  eventFilterColor.params.type = 'color';
  eventFilterColor.params.selectorName = 'input.checkboxFilter';
  eventFilterColor.params.attributeName = 'title';
  eventFilterColor.getLabel = function($element, data, jqEvent, jqData) {
    const type = this.params.type;
    const value = $element
      .find(this.params.selectorName)
      .attr(this.params.attributeName);
    return (
      optionnalSearchedPhrase() + type + AnalyticsConstants.concatenator + value
    );
  };
  eventFilterColor.postAction(($element, data, jqEvent, jqData, event) => {
    CUBE.Analytics.filters.setFilterInDataLayer($element);
  });
  tracker.addEvent(eventFilterColor);

  // - FILTER ON 'CATEGORY'
  const eventFilterCategory = new AnalyticsSlickEvent('category', baseEvent);
  eventFilterCategory.domContainer = '#product-list-categories';
  eventFilterCategory.domElement = '.product-categories-list.slick-slider a';
  eventFilterCategory.options.action = 'CategoryCarrousel';
  eventFilterCategory.trackArrows({
    getLabel($element) {
      if ($element.hasClass('slick-next')) return 'Next';
      if ($element.hasClass('slick-prev')) return 'Previous';
      return '';
    }
  });
  eventFilterCategory.trackElements({
    params: {
      findAttribute: 'href',
      checkElement: 'a.deselect',
      parentElement: 'div',
      valueOpen: 'Open-',
      valueClose: 'Close-',
    },
    getLabel($element) {
      const elementSelected = $element
        .closest(this.params.parentElement)
        .find(this.params.checkElement);
      if (elementSelected.length)
        return (
          this.params.valueClose +
          fwk.utils.getInfoNavFromURLForShoppingTool(
            $element.attr(this.params.findAttribute)
          )
        );
      return (
        this.params.valueOpen +
        fwk.utils.getInfoNavFromURLForShoppingTool(
          $element.attr(this.params.findAttribute)
        )
      );
    },
  });
  eventFilterCategory.postAction(function(
    $element,
    data,
    jqEvent,
    jqData,
    event
  ) {
    const filterValue = $element
      .find(this.params.selectorValue)
      .data('filter-value');
    CUBE.Analytics.filters.setFilterInDataLayer($element, filterValue, true);
  });
  tracker.addEvent(eventFilterCategory);

  // FILTER ON 'CATEGORIZED BY' (checkbox faceting)
  const eventFilterCheckbox = new AnalyticsTriggerEvent(
    'filterCheckbox',
    baseEvent
  );
  eventFilterCheckbox.trigger = 'change';
  eventFilterCheckbox.domContainer = '.m-filters-item-scroll';
  eventFilterCheckbox.domElement = 'input';
  eventFilterCheckbox.getLabel = $element => {
    const filterType = 'checkbox';
    const filterName = $element
      .closest('div.m-filters-item-content')
      .parent()
      .find('legend')
      .text()
      .trim();
    const filterValue = $element
      .parent()
      .text()
      .trim()
      .replace(/\s+/g, '')
      .replace(/\(/g,' (');
    return (
      optionnalSearchedPhrase() +
      filterType +
      AnalyticsConstants.concatenator +
      filterName +
      AnalyticsConstants.concatenator +
      filterValue
    );
  };
  eventFilterCheckbox.postAction(($element, data, jqEvent, jqData, event) => {
    CUBE.Analytics.filters.setFilterInDataLayer($element);
  });
  tracker.addEvent(eventFilterCheckbox);

  // FILTER 'SORT BY'
  const eventSortBy = new AnalyticsClickEvent('filterSortBy', baseEvent);
  eventSortBy.options.action = 'Sort';
  eventSortBy.domContainer = '#main-container';
  eventSortBy.domElement = '#product-filters-top li';
  eventSortBy.getLabel = $element =>
    optionnalSearchedPhrase() + $element[0].dataset.tnrLabel;
  tracker.addEvent(eventSortBy);

  // FILTER 'SORT BY' ( -- TRIGGER 'open' on open)
  const eventOpenSortBy = new AnalyticsClickEvent(
    'filterOpenSortBy',
    baseEvent
  );
  eventOpenSortBy.options.action = 'Sort';
  eventOpenSortBy.domContainer = '#main-container';
  eventOpenSortBy.domElement = '#js-select-option';
  eventOpenSortBy.getLabel = $element =>
    !$element.hasClass('dkt-select--open') ? 'Open' : 'Close';
  tracker.addEvent(eventOpenSortBy);

  //VISUAL FILTERS
  const eventVisualFilters = new AnalyticsClickEvent(
    'eventVisualFilters',
    baseEvent
  );
  eventVisualFilters.options.action = 'VisualFilter';
  eventVisualFilters.domElement =
    '.visual-categories a li, #product-filters-by-category li';
  eventVisualFilters.getLabel = $element => {
    let href = $element.parent().attr('href');
    if (!href) {
      href = $element.find('a').attr('href');
    }
    return `${CUBE.Analytics.utils.getInfoNavFromURL(
      href
    )}|${CUBE.Analytics.utils.getInfoNavFromURL()}`;
  };
  tracker.addEvent(eventVisualFilters);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

  const optionnalSearchedPhrase = () => {
    if (isSearch)
      return tc_vars.search_keyword + AnalyticsConstants.concatenator;
    return '';
  };
};

// -- INIT
if (window.cube.config.anly_useLegacy === 'Y' && $('#product-filters').length > 0) {
  $(() => {
    init();

    CUBE.Analytics = CUBE.Analytics || {};
    CUBE.Analytics.filters = {
      //Remove a filter present in the variable list_filters in data layer
      resetFilters(element) {
        const $element = $(element);
        if ($element.closest('#breadCrumbsFilters')) {
          if ($element.hasClass('reset-filters')) {
            this.resetAllFilters($element);
          } else {
            const filterName = $element.data('filter-name').split('.')[1];
            const filterValue = $element.data('filter-value');
            this.addOrRemoveFilterInDataLayer(
              filterName,
              filterValue,
              false,
              false,
              true
            );
          }
        }
      },

      //Remove all filters presents in data layer
      resetAllFilters($element) {
        $('#breadCrumbsFilters')
          .find('.removeFilter:not(.reset-filters)')
          .each(function() {
            const $filter = $(this);
            const filterName = $filter.data('filter-name').split('.')[1];
            const filterValue = $filter.data('filter-value');
            CUBE.Analytics.filters.addOrRemoveFilterInDataLayer(
              filterName,
              filterValue,
              false,
              false,
              false
            );
          });
        this.sendPageViewForFilters();
      },

      setFilterInDataLayer($element, filterValue, filterSelected) {
        const filterName = $element
          .closest('[data-filter-name]')
          .data('filter-name')
          .split('.')[1];
        const filterUnique =
          $element.closest('[data-filter-name]').data('filter-unique') === 'Y';
        filterValue =
          filterValue ||
          $element.closest('[data-filter-value]').data('filter-value');
        filterSelected =
          filterSelected ||
          $element.closest('[data-filter-value]').data('filter-selected') ===
            'N';

        this.addOrRemoveFilterInDataLayer(
          filterName,
          filterValue,
          filterUnique,
          filterSelected,
          true
        );
      },

      addOrRemoveFilterInDataLayer(
        filterName,
        filterValue,
        filterUnique,
        filterSelected,
        sendPageView
      ) {
        if (filterUnique) {
          if (filterSelected) {
            //Replace this filter if present from the data layer in the variable "list_filters"
            let isReplace = false;
            for (let i = 0; i < tc_vars.list_filters.length; i++) {
              if (tc_vars.list_filters[i][0] === filterName) {
                tc_vars.list_filters[i][1] = filterValue;
                isReplace = true;
                break;
              }
            }
            if (!isReplace) {
              tc_vars.list_filters.push([filterName, filterValue]);
            }
          } else {
            //Remove this filter from the data layer in the variable "list_filters"
            for (let i = 0; i < tc_vars.list_filters.length; i++) {
              if (tc_vars.list_filters[i][0] === filterName) {
                tc_vars.list_filters.splice(i, 1);
                break;
              }
            }
          }
        } else if (filterSelected) {
          //Add this filter to the data layer in the variable "list_filters" and if not unique
          tc_vars.list_filters.push([filterName, filterValue]);
        } else {
          //Remove this filter from the data layer in the variable "list_filters"
          for (let i = 0; i < tc_vars.list_filters.length; i++) {
            if (
              tc_vars.list_filters[i][0] === filterName &&
              tc_vars.list_filters[i][1] === filterValue
            ) {
              tc_vars.list_filters.splice(i, 1);
              break;
            }
          }
        }

        if (sendPageView) {
          this.sendPageViewForFilters();
        }
      },

      sendPageViewForFilters() {
        CUBE.Analytics.sendPageView();
      }
    };
  });
}



// WEBPACK FOOTER //
// ./src/analytics/trackers/commons/filters-tracker.js